import { LsSubscriptionTableFields } from "constants/globals";

export const formats = {
  INT: "int",
  FLOAT: "float",
  STRING: "string",
  FIGURE: "figure",
  DATE: "date",
  TIME: "time",
};

export const alignment = {
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center",
};

export class HeaderListData {
  Name :string;
  IsChecked:boolean;       
};

export const direction = {
  LEFT: "left",
  RIGHT: "right",
};

export const labels = {
  SYMBOL: "Instrumento",
  CURRENT_PRICE: "Precio actual",
  CHANGE_PROCENTAGE: "Variaci\u00f3n %",
  CHANGE_UNIT: "Variaci\u00f3n unitaria",
  VOLUMEN_TOTAL: "Volume Total",
  VOLUMEN_DONE: "Volumen hecho",
  PURCHASE_PRICE: "Precio de compra",
  PURCHASE_VOLUME: "Volumen de compra",
  SALE_PRICE: "Precio de venta",
  SALE_VOLUME: "Volumen de venta",
  ISIN: "ISIN",
  PREVIOUS_PRICE_DATE: "Fecha precio anterior",
  DATE: "Fecha",
  HOUR: "Hora",
  FULL_NAME: "Nombre",
  SPREAD: "Spread",
  VALUE: "Valor actual",
  POSTURE_ASK_TIME: "Hora venta",
  PURCHASE_DATE: "Fecha compra",
  SALE_DATE: "Fecha venta",
  PREVIOUS_DATE: "Fecha anterior",
  MINIMUM: "M\u00ednimo del d\u00EDa",
  PREVIOUS_PRICE: "Precio anterior",
  PREVIOUS_PRICE_VALUE: "Valor anterior",
  MAXIMUM: "M\u00e1ximo del d\u00EDa",
  TOTAL_AMOUNT: "Importe total",
  OPENING_PRICE: "Precio de apertura",
  ACTUAL_PRICE: "Precio actual",
  ACTUAL_PRICE_VALUE: "Valor",
  PERIODICITY: "Periodicidad",
  DESCRIPTION: "Descripci\u00f3n",
  LIQUID_PRICE: "Precio de liquidaci\u00f3n",
  PREVIUS_LIQUID_PRICE: "Precio anterior de liquidaci\u00f3n",
  COMULATIVE_VOLUME: "Volumen acumulado",
  NUMBER_OPER: "N\u00famero de operaciones",
  EXPIRATION_DATE: "Fecha de expirac\u00f3n",
  VOLUME: "Volumen",
  PPP_VALUE: "Precio Promedio Ponderado",
  PPP_NUMBER: "PPP",
  BUYER: "Comprador",
  LAST_DATE: "Fecha",
  PEAK_AMOUNT: "Importe Pico",
  PURCHASE_TIME: "Hora postura",
  OPERATION: "Operaci\u00f3n",
  MAXIMUM_12_MONTHS: "Precio m\u00e1x. (Ult. 12 Meses)",
  MINIMUM_12_MONTHS: "Precio min. (Ult. 12 Meses)",
  PEAK_PRICE: "\u00daltimo precio",
  SELLER: "Vendedor",
  PEAK_VOLUME: "Volumen Pico",
  AVERAGE_PRICE: "Precio promedio",
  MONTHLY_YIELD: "Rendimiento mensual",
  ANNUAL_YIELD: "Rendimiento anual",
  WEEKLY_YIELD: "Rendimiento semanal",
  YIELD_PER_YEAR: "Rendimiento del año",
  MAX_VOLUME_52S: "Vol. Max. 52(s)",
  MIN_VOLUME_52S: "Vol. Min. 52(s)",
  AVERAGE_VOLUME_3A: "Vol. Prom. 3(a)",
  AVERAGE_VOLUME_3M: "Vol. Prom. 3(m)",
  SERIE: "Serie",
  FIXED_INCOME_DAYS_TO_EXPIRE: "D\u00edas por vencer",
  VALUE_TYPE: "Tipo de valor",
  FIXED_INCOME_RELEASE_DATE: "Fecha de emisi\u00f3n",
  FIXED_INCOME_CLEAN_PRICE: "Precio limpio",
  FIXED_INCOME_DIRTY_PRICE: "Precio sucio",
  SURTAX_PIP: "Sobretasa PIP",
  MD_CLEAN_PRICE: "Precio limpio MD",
  MD_DIRTY_PRICE: "Precio sucio MD",
  FIXED_INCOME_INTEREST_24: "Inter\u00e9s 24H",
  FIXED_INCOME_SCORE_FITCH: "Calificaci\u00f3n Fitch",
  FIXED_INCOME_SCORE_MOODY: "Calificaci\u00f3n Moody's",
  FIXED_INCOME_SCORE_SP: "Calificaci\u00f3n S&P",
  FIXED_INCOME_SCORE_HR: "Calificaci\u00f3n HR",
  FIXED_INCOME_EXPIRATION_DATE: "Fecha vencimiento",
  FIXED_INCOME_YIELD_RATE: "Tasa de rendimiento",
  COUPON_RATE: "Tasa cup\u00f3n",
  AMOUNT: "Importe",
  STOCK: "Bolsa",
  PRICE: "Precio",
  ACTUAL_VALUE: "Valor actual",
  NUM_ORDER: "N\u00fam Ordenes Compra",
  PURCHASE_VOLUME_PP: "Volumen de Compra",
  PURCHASE: "Compra",
  SALE: "Venta",
  VOL_SALE: "Volumen Venta",
  NUM_ORDERS: "N\u00fam Ordenes Venta",
  QUANTITY: "Cantidad",
  PPP: "PPP",
  LIQUIDATION: "Liquidaci\u00f3n",
  SEVEN_DAYS: "7 d\u00edas",
  THIRTY_DAYS: "30 d\u00edas",
  OF_YEAR: "Del año",
  LAST_TWELVE_MONTHS: "\u00dalt. 12 m.",
  VOLATILITY: "Volatilidad",
  PUPA: "P/UPA",
  PVL: "PVL",
  TRANSMITTER: "Emisora",
  INSTRUMENT_TYPE: "Tipo de instrumento",
  SPREAD_VARIATION: "Spread (%)",
  LAST_DONE: "\u00daltimo hecho",
  CLOSING_PRICE: "Precio de cierre",
  CHANGE: "Variaci\u00f3n",
  BROKERAGE_HOUSE: "Casa de Bolsa",
  VALOR: "Valor",
  PARTICIPATION_SHARE: "Participaci\u00f3n %",
  SALE_RATE: "Tasa de Venta",
  PURCHASE_RATE: "Tasa de Compra",
  WEEKLY_NUMBER: "Rend. Semanal",
  MONTHLY_NUMBER: "Rend. Mensual",
  ANNUAL_NUMBER: "Rend. Anual",
  ANNUAL_YIELD_NUMBER: "Rend. en el Año",
  ACCUMULATED_VOLUME: "Volumen acumulado",
  POSTURE_DATE: "Fecha postura",
  CURRENT_LEVEL: "Nivel actual",
  PREVIOUS_LEVEL: "Nivel anterior",
  FRECUENCY: "Frecuencia",
  UNITS: "Unidades",
  LAST_UPDATE: "\u00DCltima actualizaci\u00f3n",
  SERIE_TYPE: "Tipo de serie",
  PURCHASE_CASH: "Cmp. Cash",
  SALE_CASH: "Vta. Cash",
  PURCHASE_CASH_24HRS: "Cmp. 24h",
  SALE_CASH_24HRS: "Vta. 24h",
  PURCHASE_CASH_48HRS: "Cmp. 48h",
  SALE_CASH_48HRS: "Vta. 48h",
  EXPIRATION: "Vencimiento",
  AVAILABILITY: "Disponibilidad",
  SOURCE: "Source",
  PORTFOLIO: "Cartera",
  INSTRUMENT: "Instrumento",
  REND_YEAR_ANNUALIZED: "Rend. en el Año (Anualizado)",
  REND_MONTHLY_ANNUALIZED: "Rend. Mensual (Anualizado)",
  REND_WEEKLY_ANNUALIZED: "Rend. Semanal (Anualizado)",
};


export const MarketExcludedColumns = [
  {
    Market: 2,
    description: "Serie"
  },
  {
    Market: 2,
    description: "Series"
  },
  {
    Market: 2,
    description: "Tipo de instrumento"
  },
  {
    Market: 2,
    description: "Oportunidad de información"
  },
  {
    Market: 2,
    description: "Movimiento"
  },
  {
    Market: 2,
    description: "Fecha de caducidad"
  },
  {
    Market: 2,
    description: "Printable"
  },
  {
    Market: 2,
    description: "Indicador"
  },
  {
    Market: 1,
    description: "Emisora"
  },
  {
    Market: 1,
    description: "Serie"
  },
  {
    Market: 1,
    description: "Series"
  },
  {
    Market: 1,
    description: "Volumen"
  },
  {
    Market: 1,
    description: "Volumen promedio 3 años"
  },
  {
    Market: 1,
    description: "Volumen promedio 3 meses"
  },
  {
    Market: 1,
    description: "Precio promedio"
  },
  {
    Market: 1,
    description: "Operación"
  },
  {
    Market: 1,
    description: "Folio CID"
  },
  {
    Market: 1,
    description: "Precio pp"
  },
  {
    Market: 1,
    description: "Accion"
  },
  {
    Market: 1,
    description: "Pico lote"
  },
  {
    Market: 1,
    description: "Pico precio"
  },
  {
    Market: 1,
    description: "Pico volumen"
  },
  {
    Market: 1,
    description: "Pico importe"
  },
  {
    Market: 1,
    description: "Pico fecha"
  },
  {
    Market: 1,
    description: "Pico hora"
  },
  {
    Market: 1,
    description: "Capitalización"
  },
  {
    Market: 1,
    description: "Valor de empresa"
  },
  {
    Market: 1,
    description: "Tipo de instrumento"
  },
  {
    Market: 1,
    description: "Monitor hora"
  },
  {
    Market: 1,
    description: "Monitor precio"
  },
  {
    Market: 1,
    description: "Monitor volumen"
  },
  {
    Market: 1,
    description: "Monitor fecha"
  },
  {
    Market: 1,
    description: "Aire cierre"
  },
  {
    Market: 1,
    description: "Spread"
  },
  {
    Market: 1,
    description: "Spread porcentaje"
  },
  {
    Market: 1,
    description: "Oportunidad de información"
  },
  {
    Market: 1,
    description: "Yield"
  },
  {
    Market: 1,
    description: "Precio Objetivo"
  },
  {
    Market: 1,
    description: "Recomendación"
  },
  {
    Market: 1,
    description: "Llave de instrumento"
  },
  {
    Market: 1,
    description: "Descripción nombre"
  },
  {
    Market: 123,
    description: "Series"
  },
  {
    Market: 123,
    description: "Serie"
  },
  {
    Market: 123,
    description: "Precio de apertura"
  },
  {
    Market: 123,
    description: "Volumen"
  },
  {
    Market: 123,
    description: "Volumen acumulado"
  },
  {
    Market: 123,
    description: "Máximo del día"
  },
  {
    Market: 123,
    description: "Mínimo del día"
  },
  {
    Market: 123,
    description: "Precio promedio ponderado"
  },
  {
    Market: 123,
    description: "Rend. Semanal"
  },
  {
    Market: 123,
    description: "Rend. Mensual"
  },
  {
    Market: 123,
    description: "Rend. Anual"
  },
  {
    Market: 123,
    description: "Rend. en el Año"
  },
  {
    Market: 123,
    description: "Hora postura"
  },
  {
    Market: 123,
    description: "Fecha postura"
  },
  {
    Market: 123,
    description: "Precio de compra"
  },
  {
    Market: 123,
    description: "Volumen de compra"
  },
  {
    Market: 123,
    description: "Precio venta"
  },
  {
    Market: 123,
    description: "Volumen de venta"
  },
  {
    Market: 123,
    description: "Volumen máximo en el año"
  },
  {
    Market: 123,
    description: "Volumen mínimo en el año"
  },
  {
    Market: 123,
    description: "Volumen promedio 3 años"
  },
  {
    Market: 123,
    description: "Volumen promedio 3 meses"
  },
  {
    Market: 123,
    description: "Precio promedio"
  },
  {
    Market: 123,
    description: "Operación"
  },
  {
    Market: 123,
    description: "Numero de operaciones"
  },
  {
    Market: 123,
    description: "Folio CID"
  },
  {
    Market: 123,
    description: "Precio pp"
  },
  {
    Market: 123,
    description: "Fecha anterior"
  },
  {
    Market: 123,
    description: "Comprador"
  },
  {
    Market: 123,
    description: "Vendedor"
  },
  {
    Market: 123,
    description: "Accion"
  },
  {
    Market: 123,
    description: "Pico lote"
  },
  {
    Market: 123,
    description: "Pico precio"
  },
  {
    Market: 123,
    description: "Pico volumen"
  },
  {
    Market: 123,
    description: "Pico importe"
  },
  {
    Market: 123,
    description: "Pico fecha"
  },
  {
    Market: 123,
    description: "Pico hora"
  },
  {
    Market: 123,
    description: "Capitalización"
  },
  {
    Market: 123,
    description: "Valor de empresa"
  },
  {
    Market: 123,
    description: "Tipo de instrumento"
  },
  {
    Market: 123,
    description: "Monitor hora"
  },
  {
    Market: 123,
    description: "Monitor precio"
  },
  {
    Market: 123,
    description: "Monitor volumen"
  },
  {
    Market: 123,
    description: "Monitor fecha"
  },
  {
    Market: 123,
    description: "Aire cierre"
  },
  
  {
    Market:123,
    description: "Rendimiento semanal"
  },
  {
    Market:123,
    description: "Rendimiento mensual"
  },
  {
    Market:123,
    description: "Rendimiento anual"
  },
  {
    Market:123,
    description: "Rendimiento del año"
  },
  {
    Market:123,
    description: "Volumen mínimo en el año"
  },
  {
    Market:123,
    description: "Monitor volumen"
  },
  {
    Market: 64,
    description: "Oportunidad de información"
  },
  {
    Market: 64,
    description: "Precio promedio ponderado"
  },
  {
    Market: 64,
    description: "Liquidación"
  },
  {
    Market: 64,
    description: "Dias plazo"
  },
  {
    Market: 64,
    description: "Bolsa"
  },
  {
    Market: 64,
    description: "Tasa precio"
  },
  {
    Market: 64,
    description: "Fecha caducidad"
  },
  {
    Market: 64,
    description: "Importe total"
  },
  {
    Market: 64,
    description: "Tasa premio"
  },
  {
    Market: 64,
    description: "Tasa real"
  },
  {
    Market: 64,
    description: "Precio promedio"
  },
  {
    Market: 64,
    description: "Tipo mercado"
  },
  {
    Market: 64,
    description: "Tipo valor"
  },
  {
    Market: 64,
    description: "Tipo operacion"
  },
  {
    Market: 64,
    description: "Accion"
  },
  {
    Market: 64,
    description: "Folio CID"
  },
  {
    Market: 64,
    description: "Coloc"
  },
  {
    Market: 64,
    description: "p. Val. Sub"
  },
  {
    Market: 64,
    description: "Grupo"
  },
  {
    Market: 64,
    description: "Val. Sub"
  },
  {
    Market: 64,
    description: "Numero de operaciones"
  },
  {
    Market: 64,
    description: ""
  },
  {
    Market: 64,
    description: "Aire cierre"
  },
  {
    Market: 64,
    description: "Precio strike"
  },
  {
    Market: 2048,
    description: "Oportunidad de información"
  },
  {
    Market: 2048,
    description: "Precio promedio ponderado"
  },
  {
    Market: 2048,
    description: "Liquidación"
  },
  {
    Market: 2048,
    description: "Dias plazo"
  },
  {
    Market: 2048,
    description: "Bolsa"
  },
  {
    Market: 2048,
    description: "Tasa precio"
  },
  {
    Market: 2048,
    description: "Fecha caducidad"
  },
  {
    Market: 2048,
    description: "Importe total"
  },
  {
    Market: 2048,
    description: "Tasa premio"
  },
  {
    Market: 2048,
    description: "Tasa real"
  },
  {
    Market: 2048,
    description: "Precio Promedio"
  },
  {
    Market: 2048,
    description: "Tipo mercado"
  },
  {
    Market: 2048,
    description: "Tipo valor"
  },
  {
    Market: 2048,
    description: "Tipo operacion"
  },
  {
    Market: 2048,
    description: "Accion"
  },
  {
    Market: 2048,
    description: "Folio CID"
  },
  {
    Market: 2048,
    description: "Coloc"
  },
  {
    Market: 2048,
    description: "p. Val. Sub"
  },
  {
    Market: 2048,
    description: "Grupo"
  },
  {
    Market: 2048,
    description: "Val. Sub"
  },
  {
    Market: 2048,
    description: "Numero de operaciones"
  },
  {
    Market: 2048,
    description: "Aire cierre"
  },
  {
    Market: 2048,
    description: "Precio strike"
  },
  {
    Market: 32,
    description: "Id de instrumento"
  },
  {
    Market: 32,
    description: "Descipción de mercado"
  },
  {
    Market: 4096,
    description: "Oportunidad de información"
  },
  {
    Market: 4096,
    description: "Compra/Venta"
  },
  {
    Market: 4096,
    description: "Clave"
  },
  {
    Market: 4096,
    description: "Pais"
  },
  {
    Market: 32800,
    description: "Bolsa"
  },
  {
    Market: 32800,
    description: "Periodicidad"
  },
  {
    Market: 32800,
    description: "Precio de cierre"
  },
  {
    Market: 32800,
    description: "tipoMercado"
  },
  {
    Market: 32800,
    description: "tipoValor"
  },

];

export const dataTableColumns = [
  {
    label: labels.SYMBOL,
    align: alignment.LEFT,
    name: "symbol",
    format: formats.STRING,
    apiField: "instrumento",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SYMBOL,
    align: alignment.LEFT,
    name: "displaySymbol",
    format: formats.STRING,
    apiField: "displaySymbol",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.DESCRIPTION,
    align: alignment.LEFT,
    name: "description",
    format: formats.STRING,
    apiField: "descripcionInstrumento",
    lsField: "",
    lsFormat: null,
    width: "500",
  },
  {
    label: labels.ISIN,
    align: alignment.LEFT,
    name: "isin",
    format: formats.STRING,
    apiField: "isin",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.CLOSING_PRICE,
    align: alignment.RIGHT,
    name: "previousPrice",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioAnterior",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PREVIOUS_PRICE,
    align: alignment.RIGHT,
    name: "previousPrice",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "precioAnterior",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PREVIOUS_PRICE_VALUE,
    align: alignment.RIGHT,
    name: "previousPrice",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "precioAnterior",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.ACTUAL_VALUE,
    align: alignment.RIGHT,
    name: "actualPrice",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "precioActual",
    lsField: LsSubscriptionTableFields.CURRENT_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PRICE,
    align: alignment.RIGHT,
    name: "actualPrice",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "precioActual",
    lsField: LsSubscriptionTableFields.CURRENT_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PRICE,
    align: alignment.RIGHT,
    name: "actualPrice",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioActual",
    lsField: LsSubscriptionTableFields.CURRENT_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PRICE,
    align: alignment.RIGHT,
    name: "actualPrice",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioActual",
    lsField: LsSubscriptionTableFields.PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PRICE,
    align: alignment.RIGHT,
    name: "actualPrice",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "precioActual",
    lsField: LsSubscriptionTableFields.CURRENT_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.VOLUMEN_DONE,
    align: alignment.RIGHT,
    name: "volume",
    format: formats.INT,
    lsField: LsSubscriptionTableFields.VOLUMEN_DONE,
    apiField: "volumenAcumulado",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.CHANGE,
    align: alignment.RIGHT,
    name: "change",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "variacion",
    lsField: LsSubscriptionTableFields.CHANGE_UNIT,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.CHANGE_PROCENTAGE,
    align: alignment.RIGHT,
    name: "changePercentage",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "porcentaje",
    lsField: LsSubscriptionTableFields.CHANGE_PROCENTAGE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.CHANGE_PROCENTAGE,
    align: alignment.RIGHT,
    name: "changePercentage",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "variacion",
    lsField: LsSubscriptionTableFields.CHANGE_PROCENTAGE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.VOLUMEN_TOTAL,
    align: alignment.RIGHT,
    name: "totalVolume",
    format: formats.INT,
    apiField: "volumenTotal",
    lsField: LsSubscriptionTableFields.VOLUMEN_TOTAL,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.VOLUME,
    align: alignment.RIGHT,
    name: "totalVolume",
    format: formats.INT,
    apiField: "volumenTotal",
    lsField: LsSubscriptionTableFields.VOLUMEN_TOTAL,
    lsFormat: null,
  },
  {
    label: labels.HOUR,
    align: alignment.RIGHT,
    name: "time",
    format: formats.TIME,
    apiField: "hora",
    lsField: LsSubscriptionTableFields.HOUR,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.HOUR,
    align: alignment.RIGHT,
    name: "time",
    format: formats.TIME,
    apiField: "horaPrecioActual",
    lsField: LsSubscriptionTableFields.HOUR,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.DATE,
    align: alignment.RIGHT,
    name: "date",
    format: formats.DATE,
    apiField: "fechaPrecioActual",
    lsField: LsSubscriptionTableFields.DATE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.LAST_DATE,
    align: alignment.RIGHT,
    name: "lastDate",
    format: formats.DATE,
    apiField: "monitorFecha",
    lsField: LsSubscriptionTableFields.LAST_DATE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.DATE,
    align: alignment.RIGHT,
    name: "currentPriceDate",
    format: formats.DATE,
    apiField: "fechaPrecioActual",
    lsField: LsSubscriptionTableFields.DATE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PREVIOUS_PRICE_DATE,
    align: alignment.RIGHT,
    name: "previousPriceDate",
    format: formats.DATE,
    apiField: "fechaPrecioAnterior",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.HOUR,
    align: alignment.RIGHT,
    name: "lastTime",
    format: formats.TIME,
    apiField: "monitorHora",
    lsField: LsSubscriptionTableFields.LAST_TIME,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.POSTURE_DATE,
    align: alignment.RIGHT,
    name: "postureDate",
    format: formats.DATE,
    apiField: "posturaFecha",
    lsField: LsSubscriptionTableFields.POSTURE_DATE,
    lsFormat: null,
    width: "auto",
    isPosture: true,
  },
  {
    label: labels.PURCHASE_TIME,
    align: alignment.RIGHT,
    name: "postureTime",
    format: formats.TIME,
    apiField: "posturaHora",
    lsField: LsSubscriptionTableFields.POSTURE_TIME,
    lsFormat: null,
    width: "auto",
    isPosture: true,
  },
  {
    label: labels.PURCHASE_PRICE,
    align: alignment.RIGHT,
    name: "purchaseValue",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "posturaPrecioCompra",
    lsField: LsSubscriptionTableFields.PURCHASE_VALUE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PURCHASE_PRICE,
    align: alignment.RIGHT,
    name: "purchaseValue",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "posturaPrecioCompra",
    lsField: LsSubscriptionTableFields.PURCHASE_VALUE,
    lsFormat: null,
    width: "auto",
    isPosture: true,
  },
  {
    label: labels.PURCHASE_PRICE,
    align: alignment.RIGHT,
    name: "purchaseValue",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "posturaPrecioCompra",
    lsField: LsSubscriptionTableFields.NYSE_PURCHASE_VALUE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PURCHASE_RATE,
    align: alignment.RIGHT,
    name: "purchaseValue",
    format: formats.FLOAT,
    decimals: 6,
    apiField: "precioCompra",
    lsField: LsSubscriptionTableFields.PURCHASE_VALUE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PURCHASE_VOLUME,
    align: alignment.RIGHT,
    name: "purchaseVolume",
    format: formats.INT,
    apiField: "posturaVolumenCompra",
    lsField: LsSubscriptionTableFields.PURCHASE_VOLUME,
    lsFormat: null,
    width: "auto",
    isPosture: true,
  },
  {
    label: labels.PURCHASE_VOLUME,
    align: alignment.RIGHT,
    name: "purchaseVolume",
    format: formats.INT,
    apiField: "posturaVolumenCompra",
    lsField: LsSubscriptionTableFields.NYSE_PURCHASE_VOLUME,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SALE_PRICE,
    align: alignment.RIGHT,
    name: "saleValue",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "posturaPrecioVenta",
    lsField: LsSubscriptionTableFields.SALE_VALUE,
    lsFormat: null,
    width: "auto",
    isPosture: true,
  },
  {
    label: labels.SALE_PRICE,
    align: alignment.RIGHT,
    name: "saleValue",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "posturaPrecioVenta",
    lsField: LsSubscriptionTableFields.NYSE_SALE_VALUE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SALE_PRICE,
    align: alignment.RIGHT,
    name: "saleValue",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "posturaPrecioVenta",
    lsField: LsSubscriptionTableFields.SALE_VALUE,
    lsFormat: null,
    width: "auto",
    isPosture: true,
  },
  {
    label: labels.SALE_VOLUME,
    align: alignment.RIGHT,
    name: "saleVolume",
    format: formats.INT,
    apiField: "posturaVolumenVenta",
    lsField: LsSubscriptionTableFields.SALE_VOLUME,
    lsFormat: null,
    width: "auto",
    isPosture: true,
  },
  {
    label: labels.SALE_VOLUME,
    align: alignment.RIGHT,
    name: "saleVolume",
    format: formats.INT,
    apiField: "posturaVolumenVenta",
    lsField: LsSubscriptionTableFields.NYSE_SALE_VOLUME,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PPP_VALUE,
    align: alignment.RIGHT,
    name: "pppValue",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioPP",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PPP_NUMBER,
    align: alignment.RIGHT,
    name: "pppNumber",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "pppOficial",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.BUYER,
    align: alignment.RIGHT,
    name: "buyer",
    format: formats.STRING,
    apiField: "comprador",
    lsField: LsSubscriptionTableFields.BUYER,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SELLER,
    align: alignment.RIGHT,
    name: "seller",
    format: formats.STRING,
    apiField: "vendedor",
    lsField: LsSubscriptionTableFields.SELLER,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PEAK_AMOUNT,
    align: alignment.RIGHT,
    name: "peakAmount",
    format: formats.FLOAT,
    apiField: "ImportePico",
    lsField: LsSubscriptionTableFields.PEAK_AMOUNT,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.TOTAL_AMOUNT,
    align: alignment.RIGHT,
    name: "totalAmount",
    format: formats.FLOAT,
    apiField: "importeTotal",
    lsField: LsSubscriptionTableFields.TOTAL_AMOUNT,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.OPERATION,
    align: alignment.RIGHT,
    name: "operation",
    format: formats.STRING,
    apiField: "picoLote",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.OPENING_PRICE,
    align: alignment.RIGHT,
    name: "openingPrice",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioApertura",
    lsField: LsSubscriptionTableFields.OPENING_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.OPENING_PRICE,
    align: alignment.RIGHT,
    name: "openingPrice",
    format: formats.FIGURE,
    apiField: "precioApertura",
    lsField: LsSubscriptionTableFields.OPENING_PRICE,
    lsFormat: null,
  },
  {
    label: labels.MAXIMUM,
    align: alignment.RIGHT,
    name: "maxDayPrice",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioMaximoDia",
    lsField: LsSubscriptionTableFields.MAXIMUM,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MAXIMUM,
    align: alignment.RIGHT,
    name: "maxDayPrice",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioMaximoDia",
    lsField: LsSubscriptionTableFields.NYSE_MAX_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MAXIMUM,
    align: alignment.RIGHT,
    name: "maxDayPrice",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "precioMaximoDia",
    lsField: LsSubscriptionTableFields.MAXIMUM,
    lsFormat: null,
  },
  {
    label: labels.MAXIMUM_12_MONTHS,
    align: alignment.RIGHT,
    name: "maxPrice12Months",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioMaximo",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MINIMUM,
    align: alignment.RIGHT,
    name: "minDayPrice",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioMinimoDia",
    lsField: LsSubscriptionTableFields.MINIMUM,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MINIMUM,
    align: alignment.RIGHT,
    name: "minDayPrice",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioMinimoDia",
    lsField: LsSubscriptionTableFields.NYSE_MIN_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MINIMUM,
    align: alignment.RIGHT,
    name: "minDayPrice",
    format: formats.FIGURE,
    decimals: 4,
    apiField: "precioMinimoDia",
    lsField: LsSubscriptionTableFields.MINIMUM,
    lsFormat: null,
  },
  {
    label: labels.MINIMUM_12_MONTHS,
    align: alignment.RIGHT,
    name: "minPrice12Months",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioMinimo",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PEAK_PRICE,
    align: alignment.RIGHT,
    name: "peakPrice",
    format: formats.FLOAT,
    apiField: "precioPico",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PEAK_VOLUME,
    align: alignment.RIGHT,
    name: "peakVolume",
    format: formats.FLOAT,
    apiField: "volumenPico",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.AVERAGE_PRICE,
    align: alignment.RIGHT,
    name: "averagePrice",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "precioPromedio",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MONTHLY_YIELD,
    align: alignment.RIGHT,
    name: "monthlyYield",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "rendimientoMensual",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.ANNUAL_YIELD,
    align: alignment.RIGHT,
    name: "annualYield",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "rendimientoAnual",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.WEEKLY_YIELD,
    align: alignment.RIGHT,
    name: "weeklyYield",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "rendimientoSemanal",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.YIELD_PER_YEAR,
    align: alignment.RIGHT,
    name: "yieldPerYear",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "rendimientoAlAnio",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FULL_NAME,
    align: alignment.LEFT,
    name: "fullName",
    format: formats.STRING,
    apiField: "descripcionInstrumento",
    lsField: "",
    lsFormat: null,
    customStyle: {
      width: 400,
    },
    width: "400",
  },
  {
    label: labels.FULL_NAME,
    align: alignment.LEFT,
    name: "nombre",
    format: formats.STRING,
    apiField: "nombre",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MAX_VOLUME_52S,
    align: alignment.RIGHT,
    name: "maximumVolume52s",
    format: formats.INT,
    apiField: "volumenMaximo52s",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MIN_VOLUME_52S,
    align: alignment.RIGHT,
    name: "minimumVolume52s",
    format: formats.INT,
    apiField: "volumenMinimo52s",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.AVERAGE_VOLUME_3A,
    align: alignment.RIGHT,
    name: "averageVolume3a",
    format: formats.INT,
    apiField: "volumenPromedio3a",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.AVERAGE_VOLUME_3M,
    align: alignment.RIGHT,
    name: "averageVolume3m",
    format: formats.INT,
    apiField: "volumenPromedio3m",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.POSTURE_ASK_TIME,
    align: alignment.RIGHT,
    name: "postureAskTime",
    format: formats.TIME,
    apiField: "posturaHoraVenta",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PURCHASE_DATE,
    align: alignment.RIGHT,
    name: "purchaseDate",
    format: formats.DATE,
    apiField: "posturaFechaCompra",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SALE_DATE,
    align: alignment.RIGHT,
    name: "saleDate",
    format: formats.DATE,
    apiField: "posturaFechaVenta",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SPREAD,
    align: alignment.RIGHT,
    name: "spread",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "spread",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PRICE,
    align: alignment.RIGHT,
    name: "price",
    format: formats.FLOAT,
    decimals: 3,
    apiField: "precioActual",
    lsField: LsSubscriptionTableFields.PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.LIQUID_PRICE,
    align: alignment.RIGHT,
    name: "liquidPrice",
    format: formats.FLOAT,
    decimals: 3,
    apiField: "precioLiquidacion",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PREVIUS_LIQUID_PRICE,
    align: alignment.RIGHT,
    name: "previousLiquidPrice",
    format: formats.FLOAT,
    decimals: 3,
    apiField: "precioLiquidacionAnterior",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.VOLUME,
    align: alignment.CENTER,
    name: "cumulativeVolume",
    format: formats.INT,
    apiField: "volumenAcumulado",
    lsField: LsSubscriptionTableFields.VOLUMEN_TOTAL,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MAXIMUM,
    align: alignment.RIGHT,
    name: "maxDayPrice",
    format: formats.FLOAT,
    decimals: 3,
    apiField: "precioMaximoDia",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MINIMUM,
    align: alignment.RIGHT,
    name: "minDayPrice",
    format: formats.FLOAT,
    decimals: 3,
    apiField: "precioMinimoDia",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.CHANGE,
    align: alignment.RIGHT,
    name: "changeUnit",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "variacion",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.EXPIRATION_DATE,
    align: alignment.RIGHT,
    name: "expirationDate",
    format: formats.DATE,
    apiField: "fechaExpiracion",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.OPENING_PRICE,
    align: alignment.RIGHT,
    name: "openingPrice",
    format: formats.FLOAT,
    decimals: 3,
    apiField: "precioApertura",
    lsField: LsSubscriptionTableFields.OPENING_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PREVIOUS_PRICE,
    align: alignment.RIGHT,
    name: "previousPrice",
    format: formats.FLOAT,
    decimals: 3,
    apiField: "precioAnterior",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.CHANGE_PROCENTAGE,
    align: alignment.RIGHT,
    name: "changePercentage",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "VariacionPorcentual",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PERIODICITY,
    align: alignment.RIGHT,
    name: "periodicity",
    format: formats.STRING,
    apiField: "periodicidad",
    lsField: LsSubscriptionTableFields.PERIODICITY,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SERIE,
    align: alignment.RIGHT,
    name: "serie",
    format: formats.STRING,
    apiField: "Deuda_Serie",
    lsField: "serie",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_DAYS_TO_EXPIRE,
    align: alignment.RIGHT,
    name: "fixedIncomeDaysToExpire",
    format: formats.STRING,
    apiField: "diasPorVencer",
    lsField: LsSubscriptionTableFields.FIXED_INCOME_DAYS_TO_WIN,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.VALUE_TYPE,
    align: alignment.RIGHT,
    name: "valueType",
    format: formats.STRING,
    apiField: "tipoValor",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_RELEASE_DATE,
    align: alignment.RIGHT,
    name: "fixedIncomeReleaseDate",
    format: formats.DATE,
    apiField: "Deuda_FechaEmision",
    lsField: LsSubscriptionTableFields.FIXED_INCOME_DATE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_CLEAN_PRICE,
    align: alignment.RIGHT,
    name: "fixedIncomeCleanPrice",
    format: formats.FLOAT,
    apiField: "Deuda_PrecioLimpio",
    decimals: 3,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_CLEAN_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_DIRTY_PRICE,
    align: alignment.RIGHT,
    name: "fixedIncomeDirtyPrice",
    format: formats.FLOAT,
    apiField: "Deuda_PrecioSucio",
    decimals: 3,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_DIRTY_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SURTAX_PIP,
    align: alignment.RIGHT,
    name: "surtaxPIP",
    format: formats.FLOAT,
    apiField: "sobretasaPIP",
    decimals: 6,
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MD_CLEAN_PRICE,
    align: alignment.RIGHT,
    name: "fixedIncomeMDCleanPrice",
    format: formats.FLOAT,
    apiField: "precioLimpio",
    decimals: 3,
    lsField: "",
    lsFormat: null,
    width: "auto",
  },

  {
    label: labels.MD_DIRTY_PRICE,
    align: alignment.RIGHT,
    name: "fixedIncomeMDDirtyPrice",
    format: formats.FLOAT,
    apiField: "precioSucio",
    decimals: 3,
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.AMOUNT,
    align: alignment.RIGHT,
    name: "amount",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "importe",
    lsField: LsSubscriptionTableFields.AMOUNT,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.VOLUME,
    align: alignment.RIGHT,
    name: "volume",
    format: formats.INT,
    apiField: "volumenHecho",
    lsField: LsSubscriptionTableFields.VOLUMEN_DONE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.VOLUME,
    align: alignment.RIGHT,
    name: "volume",
    format: formats.INT,
    apiField: "volumenHecho",
    lsField: LsSubscriptionTableFields.NYSE_NASDAQ_EQUITY_VOLUME_DONE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PREVIOUS_DATE,
    align: alignment.RIGHT,
    name: "previousPriceDate",
    format: formats.DATE,
    apiField: "fechaPrecioAnterior",
    lsField: LsSubscriptionTableFields.DATE_UHA,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.NUMBER_OPER,
    align: alignment.RIGHT,
    name: "numOfOperations",
    format: formats.INT,
    apiField: "numeroOperaciones",
    lsField: LsSubscriptionTableFields.NUMBER_OPERATION,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_INTEREST_24,
    align: alignment.RIGHT,
    name: "fixedIncomeInterest24",
    format: formats.FLOAT,
    apiField: "interes24h",
    decimals: 4,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_INTEREST_24,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MAXIMUM,
    align: alignment.RIGHT,
    name: "fixedIncomeDayMaxValue",
    format: formats.FLOAT,
    apiField: "precioMaximoDia",
    decimals: 3,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_DAY_MAX,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.MINIMUM,
    align: alignment.RIGHT,
    name: "fixedIncomeDayMinValue",
    format: formats.FLOAT,
    apiField: "precioMinimoDia",
    decimals: 3,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_DAY_MIN,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PURCHASE_PRICE,
    align: alignment.RIGHT,
    name: "fixedIncomeBuy",
    format: formats.FLOAT,
    apiField: "precioCompra",
    decimals: 3,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_PURCHASE_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_YIELD_RATE,
    align: alignment.RIGHT,
    name: "fixedIncomeYieldRate",
    format: formats.FLOAT,
    apiField: "tasaRendimiento",
    decimals: 6,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_YIELD_RATE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SALE_PRICE,
    align: alignment.RIGHT,
    name: "fixedIncomeSale",
    format: formats.FLOAT,
    apiField: "precioVenta",
    decimals: 3,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_SALE_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SALE_RATE,
    align: alignment.RIGHT,
    name: "fixedIncomeSale",
    format: formats.FLOAT,
    apiField: "precioVenta",
    decimals: 6,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_SALE_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.COUPON_RATE,
    align: alignment.RIGHT,
    name: "fixedCouponRate",
    format: formats.FLOAT,
    apiField: "tasaCupon",
    decimals: 4,
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.OPENING_PRICE,
    align: alignment.RIGHT,
    name: "openingPrice",
    format: formats.FLOAT,
    apiField: "precioApertura",
    decimals: 6,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_OPENING_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PREVIOUS_PRICE,
    align: alignment.RIGHT,
    name: "fixedIncomeLastPrice",
    format: formats.FLOAT,
    apiField: "precioAnterior",
    decimals: 6,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_PREVIOUS_PRICE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PRICE,
    align: alignment.RIGHT,
    name: "fixedIncomeLastDone",
    format: formats.FLOAT,
    apiField: "precioActual",
    decimals: 6,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_LAST_DONE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.CHANGE_PROCENTAGE,
    align: alignment.RIGHT,
    name: "fixedIncomePorcentualVariation",
    format: formats.FLOAT,
    decimals: 4,
    apiField: "porcentaje",
    lsField: LsSubscriptionTableFields.FIXED_INCOME_PORCENTUAL_VARIATION,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_SCORE_FITCH,
    align: alignment.RIGHT,
    name: "fixedIncomeScoreFitch",
    format: formats.STRING,
    apiField: "calificacionFitch",
    lsField: LsSubscriptionTableFields.FIXED_INCOME_SCORE_FITCH,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_SCORE_MOODY,
    align: alignment.RIGHT,
    name: "fixedIncomeScoreMoody",
    format: formats.STRING,
    apiField: "calificacionMoody",
    lsField: LsSubscriptionTableFields.FIXED_INCOME_SCORE_MOODY,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_SCORE_HR,
    align: alignment.RIGHT,
    name: "fixedIncomeScoreHR",
    format: formats.STRING,
    apiField: "calificacionHR",
    lsField: LsSubscriptionTableFields.FIXED_INCOME_SCORE_HR,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_SCORE_SP,
    align: alignment.RIGHT,
    name: "fixedIncomeScoreSP",
    format: formats.STRING,
    apiField: "calificacionSP",
    lsField: LsSubscriptionTableFields.FIXED_INCOME_SCORE_SP,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.CHANGE_UNIT,
    align: alignment.RIGHT,
    name: "fixedIncomeUnitVariation",
    format: formats.FLOAT,
    apiField: "variacion",
    decimals: 3,
    lsField: LsSubscriptionTableFields.FIXED_INCOME_UNIT_VARIATION,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FIXED_INCOME_EXPIRATION_DATE,
    align: alignment.RIGHT,
    name: "fixedIncomeExpirationDate",
    format: formats.DATE,
    apiField: "fechaVencimiento",
    lsField: LsSubscriptionTableFields.FIXED_INCOME_EXPIRATION_DATE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.HOUR,
    align: alignment.RIGHT,
    name: "fixedIncomeHour",
    format: formats.TIME,
    apiField: "horaPrecioActual",
    lsField: LsSubscriptionTableFields.FIXED_INCOME_HOUR,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.NUMBER_OPER,
    align: alignment.RIGHT,
    name: "numOfOperations",
    format: formats.INT,
    apiField: "numOperaciones",
    lsField: LsSubscriptionTableFields.NUM_OF_OPERATIONS,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.DATE,
    align: alignment.RIGHT,
    name: "date",
    format: formats.DATE,
    apiField: "fechaPrecioActual",
    lsField: LsSubscriptionTableFields.DATE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.STOCK,
    align: alignment.LEFT,
    name: "market",
    format: formats.STRING,
    apiField: "descripcionMercado",
    lsField: "",
    lsFormat: null,
  },
  {
    label: labels.SYMBOL,
    align: alignment.LEFT,
    name: "symbol",
    format: formats.STRING,
    apiField: "descripcion",
    lsField: "",
    lsFormat: null,
  },
  {
    label: labels.NUM_ORDER,
    align: alignment.RIGHT,
    name: "CNumOrdenes",
    format: formats.INT,
    apiField: "NumOpCompra",
    lsField: "CNumOrdenes",
    lsFormat: null,
  },
  {
    label: labels.PURCHASE_VOLUME_PP,
    align: alignment.RIGHT,
    name: "CVolAcumulado",
    format: formats.INT,
    apiField: "VolAcCompra",
    lsField: "CVolAcumulado",
    lsFormat: null,
  },
  {
    label: labels.PURCHASE,
    align: alignment.RIGHT,
    name: "CPrecio",
    format: formats.FLOAT,
    apiField: "PrecioCompra",
    lsField: "CPrecio",
    lsFormat: null,
  },
  {
    label: labels.SALE,
    align: alignment.RIGHT,
    name: "VPrecio",
    format: formats.FLOAT,
    apiField: "PrecioVenta",
    lsField: "VPrecio",
    lsFormat: null,
  },
  {
    label: labels.VOL_SALE,
    align: alignment.RIGHT,
    name: "VVolAcumulado",
    format: formats.INT,
    apiField: "VolAcVenta",
    lsField: "VVolAcumulado",
    lsFormat: null,
  },
  {
    label: labels.NUM_ORDERS,
    align: alignment.RIGHT,
    name: "VNumOrdenes",
    format: formats.INT,
    apiField: "NumOpVenta",
    lsField: "VNumOrdenes",
    lsFormat: null,
  },
  {
    label: labels.HOUR,
    align: alignment.RIGHT,
    name: "hour",
    format: formats.TIME,
    apiField: "hora",
    lsField: LsSubscriptionTableFields.HOUR,
    lsFormat: null,
  },
  {
    label: labels.BUYER,
    align: alignment.LEFT,
    name: "buyer",
    format: formats.STRING,
    apiField: "comprador",
    lsField: LsSubscriptionTableFields.BUYER,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SELLER,
    align: alignment.LEFT,
    name: "seller",
    format: formats.STRING,
    apiField: "vendedor",
    lsField: LsSubscriptionTableFields.SELLER,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.VOLUME,
    align: alignment.RIGHT,
    name: "quantity",
    format: formats.INT,
    apiField: "cantidad",
    lsField: LsSubscriptionTableFields.VOLUMEN_DONE,
    lsFormat: null,
  },
  {
    label: labels.VALUE,
    align: alignment.RIGHT,
    name: "value",
    format: formats.FLOAT,
    apiField: "precio",
    lsField: LsSubscriptionTableFields.CURRENT_PRICE,
    lsFormat: null,
  },
  {
    label: labels.PPP,
    align: alignment.RIGHT,
    name: "ppp",
    format: formats.FLOAT,
    apiField: "preciopp",
    lsField: "",
    lsFormat: null,
  },
  {
    label: labels.OPERATION,
    align: alignment.LEFT,
    name: "operation",
    format: formats.STRING,
    apiField: "PicoLote",
    lsField: LsSubscriptionTableFields.GRAPH,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.LIQUIDATION,
    align: alignment.RIGHT,
    name: "liquidation",
    format: formats.INT,
    apiField: "Liquidacion",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.TRANSMITTER,
    align: alignment.LEFT,
    name: "Emisor",
    format: formats.STRING,
    apiField: "Emisor",
    lsField: "",
    lsFormat: null,
    width: "75px",
  },
  {
    label: labels.SEVEN_DAYS,
    align: alignment.LEFT,
    name: "Rend7Dias",
    format: formats.FLOAT,
    apiField: "Rend7Dias",
    lsField: "",
    lsFormat: null,
    width: "75px",
  },
  {
    label: labels.THIRTY_DAYS,
    align: alignment.LEFT,
    name: "Rend30Dias",
    format: formats.FLOAT,
    apiField: "Rend30Dias",
    lsField: "",
    lsFormat: null,
    width: "75px",
  },
  {
    label: labels.OF_YEAR,
    align: alignment.LEFT,
    name: "RendAno",
    format: formats.FLOAT,
    apiField: "RendAno",
    lsField: "",
    lsFormat: null,
    width: "75px",
  },
  {
    label: labels.LAST_TWELVE_MONTHS,
    align: alignment.LEFT,
    name: "Rend12Meses",
    format: formats.FLOAT,
    apiField: "Rend12Meses",
    lsField: "",
    lsFormat: null,
    width: "75px",
  },
  {
    label: labels.VOLATILITY,
    align: alignment.LEFT,
    name: "VolatilidadAnual",
    format: formats.FLOAT,
    apiField: "VolatilidadAnual",
    lsField: "",
    lsFormat: null,
    width: "75px",
  },
  {
    label: labels.PUPA,
    align: alignment.LEFT,
    name: "PUPA",
    format: formats.FLOAT,
    apiField: "PUPA",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PVL,
    align: alignment.LEFT,
    name: "PVL",
    format: formats.FLOAT,
    apiField: "PVL",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SPREAD,
    align: alignment.RIGHT,
    name: "spread",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "spread",
    lsField: "",
    lsFormat: null,
    width: "auto",
    isPosture: true,
  },
  {
    label: labels.SPREAD_VARIATION,
    align: alignment.RIGHT,
    name: "spreadPorcentaje",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "spreadPorcentaje",
    lsField: "",
    lsFormat: null,
    width: "auto",
    isPosture: true,
  },
  {
    label: labels.SPREAD,
    align: alignment.RIGHT,
    name: "spread",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "spread",
    lsField: LsSubscriptionTableFields.SPREAD,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SPREAD_VARIATION,
    align: alignment.RIGHT,
    name: "spreadPorcentaje",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "spreadPorcentaje",
    lsField: LsSubscriptionTableFields.SPREAD_PORCENTAJE,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.INSTRUMENT_TYPE,
    align: alignment.LEFT,
    name: "instrumentTpe",
    format: formats.STRING,
    apiField: "tipoInstrumento",
    lsField: "",
    lsFormat: null,
  },
  {
    label: labels.BROKERAGE_HOUSE,
    align: alignment.LEFT,
    name: "Casa de bolsa",
    format: formats.STRING,
    apiField: "casaBolsa",
    lsField: "",
    lsFormat: null,
  },
  {
    label: labels.OPERATION,
    align: alignment.LEFT,
    name: "Operacion",
    format: formats.STRING,
    apiField: "clave",
    lsField: LsSubscriptionTableFields.GRAPH,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.NUMBER_OPER,
    align: alignment.RIGHT,
    name: "Numero de operaciones",
    format: formats.INT,
    apiField: "numeroOperacion",
    lsField: LsSubscriptionTableFields.GRAPH,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.VOLUME,
    align: alignment.RIGHT,
    name: "Volumen",
    format: formats.INT,
    apiField: "volumen",
    lsField: LsSubscriptionTableFields.GRAPH,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PARTICIPATION_SHARE,
    align: alignment.RIGHT,
    name: "Importe",
    format: formats.FLOAT,
    apiField: "porcentajeParticipacion",
    lsField: LsSubscriptionTableFields.GRAPH,
    lsFormat: null,
    width: "auto",
    isPercentage: true,
  },
  {
    label: labels.WEEKLY_NUMBER,
    align: alignment.RIGHT,
    name: "semunalNumber",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "rendimientoSemanal",
    lsField: "",
    lsFormat: null,
    width: "auto",
    isPercentage: false,
  },
  {
    label: labels.MONTHLY_NUMBER,
    align: alignment.RIGHT,
    name: "monthlyNumber",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "rendimientoMensual",
    lsField: "",
    lsFormat: null,
    width: "auto",
    isPercentage: false,
  },
  {
    label: labels.ANNUAL_NUMBER,
    align: alignment.RIGHT,
    name: "annualNumber",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "rendimientoAnual",
    lsField: "",
    lsFormat: null,
    width: "auto",
    isPercentage: false,
  },
  {
    label: labels.ANNUAL_YIELD_NUMBER,
    align: alignment.RIGHT,
    name: "rendEnAnoNumber",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "rendimientoAlAnio",
    lsField: "",
    lsFormat: null,
    width: "auto",
    isPercentage: false,
  },
  {
    label: labels.ACCUMULATED_VOLUME,
    align: alignment.RIGHT,
    name: "accumulatedVolume",
    format: formats.INT,
    apiField: "volumenTotal",
    lsField: LsSubscriptionTableFields.VOLUMEN_TOTAL,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.CURRENT_LEVEL,
    align: alignment.RIGHT,
    name: "currentLevel",
    format: formats.FLOAT,
    apiField: "valorActual",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PURCHASE_CASH,
    align: alignment.RIGHT,
    name: "purchaseCash",
    format: formats.INT,
    apiField: "cashCompra",
    lsField: LsSubscriptionTableFields.BUY_CASH,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PREVIOUS_LEVEL,
    align: alignment.RIGHT,
    name: "previousLevel",
    format: formats.FLOAT,
    apiField: "valorAnterior",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SALE_CASH,
    align: alignment.RIGHT,
    name: "saleCash",
    format: formats.INT,
    apiField: "cashVenta",
    lsField: LsSubscriptionTableFields.SALE_CASH,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.FRECUENCY,
    align: alignment.RIGHT,
    name: "frecuency",
    format: formats.STRING,
    apiField: "frecuencia",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PURCHASE_CASH_24HRS,
    align: alignment.RIGHT,
    name: "purchaseCash24hrs",
    format: formats.INT,
    apiField: "compra24hrs",
    lsField: LsSubscriptionTableFields.BUY_24HR,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.UNITS,
    align: alignment.RIGHT,
    name: "units",
    format: formats.STRING,
    apiField: "unidad",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SALE_CASH_24HRS,
    align: alignment.RIGHT,
    name: "saleCash24hrs",
    format: formats.INT,
    apiField: "venta24hrs",
    lsField: LsSubscriptionTableFields.SALE_24HR,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.LAST_UPDATE,
    align: alignment.RIGHT,
    name: "lastUpdate",
    format: formats.DATE,
    apiField: "ultimaFecha",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.PURCHASE_CASH_48HRS,
    align: alignment.RIGHT,
    name: "purchaseCash48hrs",
    format: formats.INT,
    apiField: "compra48hrs",
    lsField: LsSubscriptionTableFields.BUY_48HR,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SERIE_TYPE,
    align: alignment.RIGHT,
    name: "serieType",
    format: formats.STRING,
    apiField: "tipoSerie",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SALE_CASH_48HRS,
    align: alignment.RIGHT,
    name: "saleCash48hrs",
    format: formats.INT,
    apiField: "venta48hrs",
    lsField: LsSubscriptionTableFields.SALE_48HR,
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.EXPIRATION,
    align: alignment.LEFT,
    name: "expiration",
    format: formats.STRING,
    apiField: "vencimiento",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.AVAILABILITY,
    align: alignment.LEFT,
    name: "availability",
    format: formats.STRING,
    apiField: "diponibilidad",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.SOURCE,
    align: alignment.LEFT,
    name: "source",
    format: formats.STRING,
    apiField: "fuente",
    lsField: "",
    lsFormat: null,
    width: "auto",
  },
  {
    label: labels.REND_YEAR_ANNUALIZED,
    align: alignment.RIGHT,
    name: "rendYearAnnualized",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "rendimientoAnualAnualizado",
    lsField: "",
    lsFormat: null,
    width: "auto",
    isPercentage: true,
  },
  {
    label: labels.REND_MONTHLY_ANNUALIZED,
    align: alignment.RIGHT,
    name: "rendMonthlyAnnualized",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "rendimientoMensualAnualizado",
    lsField: "",
    lsFormat: null,
    width: "auto",
    isPercentage: true,
  },
  {
    label: labels.REND_WEEKLY_ANNUALIZED,
    align: alignment.RIGHT,
    name: "rendWeeklyAnnualized",
    format: formats.FLOAT,
    decimals: 2,
    apiField: "rendimientoSemanalAnualizado",
    lsField: "",
    lsFormat: null,
    width: "auto",
    isPercentage: true,
  },
];


export const historyColumList = [
  {
    label: "Fecha",
    align: "right",
    name: "Fecha",
    format: "date",
    width: "auto",
    decimals:0.0,
     apiField:"", 
     lsField:"",
      lsFormat:""
  },
  {
    label: "Apertura",
    align: "right",
    name: "Apertura",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Cierre",
    align: "right",
    name: "Cierre",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Máximo",
    align: "right",
    name: "Máximo",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Mínimo",
    align: "right",
    name: "Mínimo",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Volumen",
    align: "right",
    name: "Volumen",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Precio",
    align: "right",
    name:  "Precio",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Valor",
    align: "right",
    name:  "Valor",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Nivel",
    align: "right",
    name:  "Nivel",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Rendimiento en el año",
    align: "right",
    name:  "Rendimiento en el año",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Rendimiento mensual",
    align: "right",
    name:  "Rendimiento mensual",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
    lsFormat:""
  },
  {
    label: "Rendimiento semanal",
    align: "right",
    name:  "Rendimiento semanal",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
    lsFormat:""
  },
  {
    label: "Rendimiento anual",
    align: "right",
    name:  "Rendimiento anual",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Rendimiento anualizado en el año",
    align: "right",
    name:  "Rendimiento anualizado en el año",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Rendimiento anualizado mensual",
    align: "right",
    name:  "Rendimiento anualizado mensual",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },
  {
    label: "Rendimiento anualizado semanal",
    align: "right",
    name:  "Rendimiento anualizado semanal",
    format: "float",
    width: "auto",
    decimals:0.0,
    apiField:"", 
    lsField:"",
     lsFormat:""
  },


]